import { extendTailwindMerge } from 'tailwind-merge';
import { cx, type CnOptions } from 'tailwind-variants';
import { twMergeConfig as heroMergeConfig } from '@heroui/theme';

// HeroUI's own twMergeConfig only registers its font-size aliases (tiny/small/medium/large).
// Our custom typography utilities (text-m-r, text-l-sb, etc., defined as @utility rules in
// input.css) don't match font-size's literal list, so tailwind-merge falls back to classifying
// them as "text-color" (its catch-all for any unrecognized "text-*" suffix). That puts e.g.
// "text-base-20 text-m-r" in the same conflict group, and tailwind-merge silently drops the
// earlier class. Registering our suffixes as literal font-size matches fixes the classification.
const TYPOGRAPHY_SUFFIXES = [
  'xs-r',
  'xs-m',
  'xs-sb',
  's-cps',
  's-r',
  's-m',
  's-sb',
  'm-cps',
  'm-r',
  'm-m',
  'm-sb',
  'l-cps',
  'l-r',
  'l-m',
  'l-sb',
  'xl-r',
  'xl-m',
  'xl-sb',
];

const twMerge = extendTailwindMerge({
  extend: {
    theme: heroMergeConfig.theme,
    classGroups: {
      ...heroMergeConfig.classGroups,
      'font-size': [{ text: [...(heroMergeConfig.classGroups['font-size']?.[0]?.text ?? []), ...TYPOGRAPHY_SUFFIXES] }],
    },
  },
});

// Mirrors @heroui/theme's own cn (cnMerge): clsx-style input normalization via `cx`, then twMerge.
export const cn = <T extends CnOptions>(...inputs: T) => twMerge(cx(...inputs));
